import moment from "moment";
import "moment/dist/locale/da";
import "moment/dist/locale/de";
import "moment/dist/locale/es";
import "moment/dist/locale/fi";
import "moment/dist/locale/fr";
import "moment/dist/locale/it";
import "moment/dist/locale/ja";
import "moment/dist/locale/ko";
import "moment/dist/locale/nb";
import "moment/dist/locale/nl";
import "moment/dist/locale/pt";
import "moment/dist/locale/ru";
import "moment/dist/locale/sv";
import "moment/dist/locale/zh-cn";
import "moment/dist/locale/en-gb";
import "moment/dist/locale/cs";
import "moment/dist/locale/pl";
import "moment/dist/locale/cy";

if (!window.moment) {
  window.moment = moment;
}

const momentInstance = window.moment;
momentInstance.locale("en-gb");

export const changeLanguageDate = (language: string | null = "en"): void => {
  if(language === "zh") {
    language = "zh-cn"
  } 
  else if(language === "en") {
    language = "en-gb"
  }
  if(momentInstance.locale() !== language) {
    momentInstance.locale(language || "en");
  }
};

export default momentInstance;
